<template>
  <sb-modal
    class="confirm-navigation-modal"
    :active="showModal"
    :escape-trigger="false"
    :click-outside-trigger="false"
    @close="handleStay"
  >
    <div class="confirm-navigation-body">
      <h2 class="confirm-navigation-body__title">
        Unsaved Changes
      </h2>
      <div class="confirm-navigation-body__text">
        You currently have unsaved changes, would you like to continue navigation?
      </div>
      <div class="confirm-navigation-body__actions">
        <sb-button class="confirm-navigation-body__actions--leave" @click="handleLeave">
          Yes, Continue
        </sb-button>
        <sb-button
          class="confirm-navigation-body__actions--stay"
          variation="tertiary"
          @click="handleStay"
        >
          Cancel
        </sb-button>
      </div>
    </div>
  </sb-modal>
</template>

<script>
export default {
  name: 'ConfirmNavigationModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleLeave () {
      this.$emit('leave')
    },
    handleStay () {
      this.$emit('stay')
    }
  }
}
</script>

<style lang="scss">
@import '../../../assets/scss/shipbob-custom/components/orders/confirm-navigation-modal.scss';
</style>


